<template>
  <section id="cart-page">
    <div class="cart-navbar">
      <el-row type="flex" justify="between" align="middle">
        <el-col :xs="2" :sm="4">
          <div class="cart-close" @click="closeCart">
            <img src="/img/icons/cart-close.svg" alt="icon" class="img-fluid"/>
          </div>
        </el-col>
        <el-col :xs="20" :sm="16">
          <h3>Your Cart</h3>
        </el-col>
        <el-col :xs="2" :sm="4">
          <div class="cart-close">
            <img src="/img/icons/bag.svg" alt="icon" class="img-fluid"/>
            <sup class="cart-count">{{ getCart.length || 0 }}</sup>
          </div>
        </el-col>
      </el-row>
    </div>
    <section class="section-pad" v-if="getCart.length">
      <el-row type="flex" justify="center">
        <el-col :lg="20" class="cart-holder">
          <el-table :data="getCart" style="margin: 0 auto!important;max-width: 80%">
            <el-table-column label="Product Details">
              <template slot-scope="{ row }">
                <div class="product-details-container">
                  <div class="product-image">
                    <img
                      :src="row.details.images[0].image"
                      :alt="row.details.name"
                      class="img-fluid"
                    />
                  </div>
                  <div class="product-details">
                    <h3>{{ row.details.name }}</h3>
                    <p>{{ row.details.brand }}</p>
                  </div>
                </div>

              </template>
            </el-table-column>
            <el-table-column width="150px" label="Price" align="right">
              <template slot-scope="{ row }">
                <strong>{{ row.details.display_price_after_discount }}</strong>
              </template>
            </el-table-column>
            <!--                        <el-table-column width="180px" label="Shipping Cost" align="right">-->
            <!--                            <template slot-scope="{ row }">-->
            <!--                                {{ row.details.display_shipping_cost }}-->
            <!--                            </template>-->
            <!--                        </el-table-column>-->
            <el-table-column width="250px">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  class="cart-btn decrease"
                  @click.prevent="decrement(scope.row.details.id)"
                >
                  <i class="el-icon-minus"></i>
                </el-button>
                <span class="qty">{{ scope.row.qty }}</span>
                <el-button type="text"
                           size="mini"
                           title="Max can be added are 10 units"
                           :disabled="scope.row.qty >=10"
                           class="cart-btn increase" @click.prevent="addToCart(scope.row.details)">
                  <i class="el-icon-plus"></i>
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="remove(scope.$index)"
                  class="cart-btn"
                >
                  <img src="/img/icons/delete-button.png" class="img-icon" alt="delete icon"
                       aria-label="delete icon"/>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row type="flex" class="price-details container" justify="end">
        <el-col :lg="10">
          <el-row type="flex" justify="end">
            <el-col class="price-container text-right">
              <h2 class="total-price-label">Sub Total: </h2>
              <p class="price">$ {{ subTotal }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="end">
            <el-col class="price-container text-right">
              <h2 class="total-price-label">Shipping Cost: </h2>
              <p class="price">$ {{ shippingCost }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="end">
            <el-col class="price-container">
              <h2 class="total-price-label">Total Price: </h2>
              <p class="price">$ {{ totalPrice }}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <section class="container shopping-buttons">
        <el-button type="primary" @click="closeCart" class="btn btn-continue continue">Continue Shopping</el-button>
        <el-button type="primary" class="btn btn-continue" @click.prevent="captureAddress()">Proceed to Checkout
        </el-button>
      </section>
    </section>
    <section class="empty-cart-container" v-else>
      <i class="el-icon-shopping-cart-1 empty-cart"></i>
      <h1 class="empty-cart-title">Your cart is empty</h1>
      <div class="cart-container text-center">
        <el-button type="text" @click="closeCart">Continue Shopping</el-button>
      </div>
    </section>
  </section>
</template>

<script>
import CartLayout from "../../layouts/CartLayout.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      yourCart: [],
      shippingDivider: 5,
      baseShippingCost: 11
    };
  },
  computed: {
    ...mapGetters("cart", ["getCart"]),
    subTotal() {
      return (
        this.getCart.reduce(function (sum, item) {
          return sum + item.details.price * item.qty;
        }, 0) / 100
      );
    },
    shippingDivisible() {
      return Math.ceil(this.carItemsCount / this.shippingDivider )
    },
    carItemsCount() {
      return this.getCart.length
    },
    shippingCost() {
      return this.baseShippingCost * this.shippingDivisible
      // return this.getCart.reduce((sum, item) => {
      //   return sum + item.details.shipping_cost * item.qty
      // }, 0) / 100;
    },
    totalPrice() {
      return this.subTotal + this.shippingCost;
    },
  },
  created() {
    this.$emit("update:layout", CartLayout);
  },
  methods: {
    ...mapActions({
      decrement: 'cart/decrement',
      addToCart: 'cart/add',
      remove: 'cart/remove'
    }),
    closeCart() {
      this.$router.go(-1);
    },
    captureAddress() {
      this.$router.push({
        name: "checkout"
      });
    }
  }
};
</script>

<style scoped lang="scss">
#cart-page {
  .img-icon {
    width: 15px;
  }

  .price-details {
    margin-top: 15px;

    .price-container {
      display: flex;
      justify-content: end;

      .total-price-label {
        font-size: 1rem;
        font-weight: bold;
        margin-right: 10px;
        width: 60%;
        text-align: right;
      }

      .price {
        font-size: 1rem;
        text-align: right;
      }
    }
  }

  .qty {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 5px 10px;
  }

  .section-pad {

    .product-details-container {
      display: grid;
      grid-template-columns: 100px 1fr; // 100px is the image size
      grid-gap: 10px;

      .product-details {
        h3 {
          font-size: 1rem;
          word-break: break-all;
          @media all and (max-width: 768px) {
            margin-bottom: 5px;
          }
        }
      }

      .product-image {
        @media all and (max-width: 768px) {
          margin: 0 auto;
        }
        width: 100px;
        object-fit: cover;
      }
    }

    .cart-btn {
      padding: 7px 15px;

      span {
        font-weight: bold;
      }

      &.increase {
        color: #11233f;
      }

      &.decrease {
        color: #d00;
      }
    }

    .shopping-buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 15px;
      @media all and (max-width: 768px) {
        flex-direction: column;
      }

      .btn-continue {
        &.continue {
          background: #12ab0f;
          @media all and (min-width: 768px) {
            margin-left: 8%;
          }
        }

        border-radius: 6px;
        padding: 12px 55px;
        font-style: normal;
        font-weight: bold;
        outline: none;
        border: none;
        @media all and (min-width: 768px) {
          margin-right: 10%;
        }
        background-color: #11233f;
        @media all and (max-width: 768px) {
          margin: 2% 20%;
        }
      }
    }
  }

  .cart-navbar {
    padding: 20px 30px;
    background: #f8f8f8;
    text-align: center;

    .cart-close {
      cursor: pointer;
      position: relative;

      img {
        width: 15px;
      }
    }

    h3 {
      font-size: 1.563em;
      line-height: 25px;
      text-transform: uppercase;
      color: #7b7a7a;
    }

    .cart-icon {
      img {
        width: 20px;
        float: right;
      }
    }
  }

  .cart-count {
    color: #11233f;
    display: inline-block;
    font-weight: bold;
    margin-left: 3px;
    font-size: 1rem;
    top: 0;
    position: absolute;
  }

  .empty-cart-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 60vh;

    .empty-cart {
      font-size: 8rem;
      display: block;
      text-align: center;
      padding: 15px;
    }

    .empty-cart-title {
      font-size: 1.2rem;
      text-align: center;
      font-weight: bold;
      color: #11233f;
    }

    .cart-container {
      justify-content: center;
    }
  }
}

</style>
